import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="mt-5 py-3 background-site">
      <Container>
        <Row className="justify-content-center">
          <Col className="text-center ">
            <p className="mb-0 text-color-site">
              <a href="/regulation" className="text-decoration-none">Política de Privacidade</a>
              {' • '}
              <a href="/terms" className="text-decoration-none">Termos de Serviço</a>
              {' • '}
              <span>Everton Souza. Todos os direitos reservados © {new Date().getFullYear()}</span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;